// Module
var code = `<h5>{{ ::\$ctrl.bloque.t }}</h5> <div class="c__box"> <editcv-preg q="::\$q" cvmodel="::\$ctrl.cvmodel" params="::\$ctrl.params" ng-repeat="\$q in ::\$ctrl.bloque.qlist" principal="true" verrespuestas="\$ctrl.verrespuestas" verestruct="\$ctrl.verestruct"></editcv-preg> </div> `;
// Exports
module.exports = code;